'use client';
var objectKeys = function(object) {
    return Object.keys(object);
};
var objectValues = function(object) {
    return Object.values(object);
};
var objectEntries = function(object) {
    return Object.entries(object);
};

export { objectEntries, objectKeys, objectValues };
